import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { InfoDialogStyles } from "./InfoDialog.style";

interface InfoDialogProps {
  text: string;
  open: boolean;
  onClose: () => void;
}

export const InfoDialog: React.FC<InfoDialogProps> = (props) => {
  const { t } = useTranslation();
  const styles = InfoDialogStyles({});

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogContent>
        <Typography id="info-dialog-description" className={styles.text}>
          {props.text}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("button.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
